import { definition, api } from "@uesio/ui"
import { UserFileMetadata } from "../../components/field/field"
import CodeField from "../codefield/codefield"
import MarkDownField from "../markdownfield/markdownfield"
import { HighlightTheme } from "../syntax-highlight"
import File, { type FileUtilityProps } from "../file/file"

type TextOptions = {
  // The language to use for syntax highlighting
  language?: string
  // The Monaco editor theme to use
  theme?: HighlightTheme
  // An array of URIs which contain ambient type definitions to load in this code field
  typeDefinitionFileURIs?: string[]
}

export interface FileTextProps extends FileUtilityProps {
  userFile?: UserFileMetadata
  displayAs?: string
  textOptions?: TextOptions
  onChange?: (value: string) => void
}

const FileText: definition.UtilityComponent<FileTextProps> = (props) => {
  const {
    context,
    userFile,
    textOptions,
    mode,
    displayAs,
    onChange,
    readonly,
    variant,
  } = props

  const isMarkdown = displayAs === "MARKDOWN"
  const language = isMarkdown ? "markdown" : textOptions?.language
  const typeDefinitionFileURIs = textOptions?.typeDefinitionFileURIs
  const theme = textOptions?.theme
  const isEditMode = !readonly && mode === "EDIT" && onChange
  const content = api.file.useUserFile(context, userFile)

  return (
    <File {...props}>
      {userFile && onChange ? (
        isMarkdown ? (
          <MarkDownField
            context={context}
            value={content}
            mode={isEditMode ? mode : "READ"}
            setValue={onChange}
            variant={variant}
            theme={theme}
          />
        ) : (
          <CodeField
            context={context}
            value={content || ""}
            mode={isEditMode ? mode : "READ"}
            language={language}
            setValue={onChange}
            typeDefinitionFileURIs={typeDefinitionFileURIs}
            theme={theme}
          />
        )
      ) : null}
    </File>
  )
}

export type { TextOptions }

export default FileText
